<template>
  <div class="appContainer" id="top">
    <div class="main" :class="isHome ? 'home' : ''">
      <Header v-if="isHome" :isHome="isHome" />
      <MainHeader v-else :isHome="isHome" />
      <router-view />
    </div>
    <!-- <Footer /> -->
  </div>
</template>
<script>
'use strict';

// Imports.
import { mapState, useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { computed } from 'vue';
// Component imports.
import Header from '/src/pages/layout/Header.vue';
import MainHeader from '/src/pages/layout/MainHeader.vue';
// import Footer from '/src/pages/layout/Footer.vue';

// Set up the default application component.

export default {
  components: {
    Header,
    MainHeader
    // Footer
  },

  setup(props, context) {
    const router = useRouter();
    const store = useStore();

    const isHome = computed(() => {
      return router.currentRoute.value.path === '/';
    });
    return {
      router,
      isHome
    };
  },

  computed: {
    ...mapState({
      alert: state => Object.assign({}, state.alert)
    })
  },

  mounted() {
    this.$store.$toasts = this.$toasts;
  },

  watch: {
    alert: {
      deep: true,
      handler: function (newAlert) {
        let message = newAlert.message;
        if (this.lastMessage === message) {
          // TODO remove this once alert hijacking is removed
          return;
        }
        let type = newAlert.type;
        let duration = newAlert.duration;
        let metadata = newAlert.metadata ? newAlert.metadata : {};

        if (message && type) {
          this.$toasts.base('', {
            message: message,
            type: type,
            duration: duration,
            metadata: metadata
          });
          this.lastMessage = message;
        } else {
          // TODO: dispatch a clear event.
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
body {
}
.appContainer {
  display: flex;
  flex-direction: column;

  .main {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 100vh;
    background-color: #58cce4;
    background-position: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden; /* Hide scrollbars */

    .homeHeader {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  .home {
    background-image: url('./images/background.png');
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
